import { Controller as BaseController } from "@hotwired/stimulus";

export default class Controller extends BaseController {
  static targets = ["description", "copyIcon", "checkIcon", "label"];
  static values = { copy: String };

  connect() {
    this.originalLabelText = this.labelTarget.textContent;
  }

  copy() {
    const text = this.copyValue || this.descriptionTarget.innerText.trim();
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedState();
      setTimeout(() => this.resetState(), 2000);
    });
  }

  showCopiedState() {
    this.copyIconTarget.style.display = "none";
    this.checkIconTarget.style.display = "flex";
    this.labelTarget.textContent = "Copié";
  }

  resetState() {
    this.copyIconTarget.style.display = "flex";
    this.checkIconTarget.style.display = "none";
    this.labelTarget.textContent = this.originalLabelText;
  }
}
